import { useEffect, useRef, useState } from "react";

export default function useLongPress(callback = () => {}, ms = 800) {
  const [startLongPress, setStartLongPress] = useState(false);
  const isTriggered = useRef(false);
  const savedCallback = useRef(callback);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    let timerId;
    if (startLongPress) {
      timerId = setTimeout(() => {
        savedCallback.current();
        isTriggered.current = true;
        setStartLongPress(false);
      }, ms);
    } else {
      clearTimeout(timerId);
    }

    return () => {
      clearTimeout(timerId);
    };
  }, [ms, startLongPress]);

  const reset = () => {
    setStartLongPress(false);
    setTimeout(() => {
      isTriggered.current = false;
    }, 500);
  };

  return {
    handlers: {
      onMouseDown: () => setStartLongPress(true),
      onMouseUp: reset,
      onMouseLeave: reset,
      onTouchStart: () => setStartLongPress(true),
      onTouchEnd: reset,
      onContextMenu: (e) => {
        if (startLongPress) e.preventDefault();
      },
    },
    isTriggered: () => isTriggered.current,
  };
}
